import { ReactNode } from 'react';
import { Card as MuiCard, CardActionArea, CardContent } from '@mui/material';

export interface CardProps {
  children: ReactNode;
  variant?: 'default' | 'elevated' | 'outlined' | 'flat';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export function Card({
  children,
  variant = 'default',
  padding = 'md',
  className = '',
  onClick,
  style,
}: CardProps) {
  // Map variant to MUI
  const muiVariant = variant === 'outlined' ? 'outlined' : 'elevation';
  const elevation = variant === 'flat' ? 0 : variant === 'elevated' ? 2 : 1;

  // Map padding to rem values (using sx prop)
  const paddingMap = {
    none: 0,
    sm: 1,
    md: 2,
    lg: 3,
  };
  const paddingValue = paddingMap[padding];

  const cardContent = (
    <CardContent sx={{ p: paddingValue, '&:last-child': { pb: paddingValue } }}>
      {children}
    </CardContent>
  );

  return (
    <MuiCard
      variant={muiVariant}
      elevation={elevation}
      className={className}
      style={style}
      sx={{ borderRadius: 2 }}
    >
      {onClick ? (
        <CardActionArea onClick={onClick}>{cardContent}</CardActionArea>
      ) : (
        cardContent
      )}
    </MuiCard>
  );
}

